import { useEffect, useState, useCallback } from "react";
import SellersTable from "./components/SellersTable";
import Pagination from "./components/Pagination";
import {
  fetchSellers,
  updateSellerStatus,
  approveSeller,
  deleteSeller,
} from "./services/adminSellersApi";
import Spinner from "../../components/Spinner";
import { useAuth } from "../../contexts/AuthContext";

export default function AdminSellers() {
  const { auth } = useAuth();
  const token = auth?.token;
  const [pageData, setPageData] = useState(null);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [verifyingId, setVerifyingId] = useState(null);

  const size = 10;

  const loadSellers = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetchSellers({ token, page, size });
      setPageData(res);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    loadSellers();
  }, [loadSellers]);

  const handleStatusChange = async (sellerId, status) => {
    try {
      await updateSellerStatus(token, sellerId, status);

      setPageData((prev) => ({
        ...prev,
        sellers:
          prev?.sellers?.map((s) =>
            s.id === sellerId ? { ...s, status } : s,
          ) || [],
      }));
    } catch (err) {
      alert("Failed to update status");
    }
  };

  const handleApprove = async (sellerId) => {
    try {
      setVerifyingId(sellerId);

      const res = await approveSeller(token, sellerId);
      const data = res.data;

      setPageData((prev) => ({
        ...prev,
        sellers:
          prev?.sellers?.map((s) =>
            s.id === sellerId ? { ...s, licenseVerified: true } : s,
          ) || [],
      }));

      alert(data.message || "Seller approved successfully");
    } catch (err) {
      alert(err.message || "Seller approval failed");
    } finally {
      setVerifyingId(null);
    }
  };

  const handleDelete = async (sellerId) => {
    if (!window.confirm("Are you sure you want to delete this seller?")) return;

    try {
      await deleteSeller(token, sellerId);

      setPageData((prev) => ({
        ...prev,
        sellers: prev?.sellers?.filter((s) => s.id !== sellerId) || [],
      }));
    } catch (err) {
      alert("Delete failed");
    }
  };
  if (loading) {
    return <Spinner text="Loading sellers..." />;
  }

  return (
    <div className="p-4">
      <h4 className="mb-4 fw-bold">Seller Management</h4>
      <SellersTable
        sellers={pageData?.sellers || []}
        onStatusChange={handleStatusChange}
        onApprove={handleApprove}
        onDelete={handleDelete}
        loading={loading}
      />

      {pageData?.page && (
        <Pagination
          page={pageData.page.number}
          totalPages={pageData.page.totalPages}
          onPageChange={setPage}
        />
      )}
    </div>
  );
}
